import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const JobSeekerDashboard = () => {
    const [profile, setProfile] = useState({});
    const [applications, setApplications] = useState([]);
    const [resume, setResume] = useState(null);
    const [jobs, setJobs] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredJobs, setFilteredJobs] = useState([]);
    const [selectedJob, setSelectedJob] = useState(null);
    const [jobUrl, setJobUrl] = useState('');
    const navigate = useNavigate();
    const jobSeekerUsername = localStorage.getItem('username');

    useEffect(() => {
        if (!jobSeekerUsername) {
            alert('No job seeker username found. Please log in again.');
            navigate('/login');
            return;
        }

        fetchProfile();
        fetchApplications();
        fetchJobs();
    }, [jobSeekerUsername, navigate]);

    const fetchProfile = async () => {
        try {
            const response = await axios.get(`http://127.0.0.1:5000/jobseekers/profile?username=${jobSeekerUsername}`);
            setProfile(response.data || {});
        } catch (error) {
            console.error('Error fetching job seeker profile:', error);
        }
    };

    const fetchApplications = async () => {
        try {
            const response = await axios.get(`http://127.0.0.1:5000/jobseekers/applications?username=${jobSeekerUsername}`);
            setApplications(response.data || []);
        } catch (error) {
            console.error('Error fetching job applications:', error);
        }
    };

    const fetchJobs = async () => {
        try {
            const response = await axios.get('http://127.0.0.1:5000/jobs');
            setJobs(response.data.jobs || []);
            setFilteredJobs(response.data.jobs || []);
        } catch (error) {
            console.error("Error fetching jobs:", error);
        }
    };

    const handleResumeChange = (e) => {
        setResume(e.target.files[0]);
    };

    const handleResumeUpdate = async () => {
        if (!resume) {
            alert('Please select a resume to upload.');
            return;
        }

        const formData = new FormData();
        formData.append('resume', resume);
        formData.append('username', jobSeekerUsername);

        try {
            const response = await axios.post('http://127.0.0.1:5000/jobseekers/update-resume', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (response.status === 200) {
                alert('Resume updated successfully!');
            } else {
                alert('Failed to update resume.');
            }
        } catch (error) {
            console.error('Error updating resume:', error);
            alert('Failed to update resume. Please try again.');
        }
    };

    const handleSearchChange = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchQuery(query);

        const filtered = jobs.filter(job =>
            job.title.toLowerCase().includes(query) ||
            job.description.toLowerCase().includes(query)
        );
        setFilteredJobs(filtered);
    };

    const handleAutoApply = async () => {
        try {
            const response = await axios.post('http://127.0.0.1:5000/jobseekers/auto-apply', {
                username: jobSeekerUsername
            });

            if (response.status === 200) {
                alert('Successfully applied to all eligible jobs!');
                fetchApplications();
            } else {
                alert('Failed to auto-apply.');
            }
        } catch (error) {
            console.error('Error auto-applying to jobs:', error);
            alert('Failed to auto-apply to jobs. Please try again.');
        }
    };

    return (
        <div style={{ padding: '20px', maxWidth: '900px', margin: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2>Welcome, {profile.full_name || "Job Seeker"}</h2>
                <button 
                    style={{
                        padding: '10px 15px',
                        backgroundColor: '#007BFF',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                    }}
                    disabled // 🚀 Functionality will be added later
                >
                    My Interview Results for Applied Jobs (Coming Soon)
                </button>
            </div>

            {/* Profile Section */}
            <div style={{ border: '1px solid #ddd', padding: '15px', borderRadius: '5px', backgroundColor: '#f9f9f9', marginTop: '15px' }}>
                <h3>Your Profile</h3>
                <p><strong>Email:</strong> {profile.email || "Not provided"}</p>
                <p><strong>Phone:</strong> {profile.phone || "Not provided"}</p>
                <p><strong>Gender:</strong> {profile.gender || "Not specified"}</p>
                <p><strong>Veteran Status:</strong> {profile.veteran_status || "Not specified"}</p>
                <p><strong>Work Visa Status:</strong> {profile.work_visa_status || "Not specified"}</p>
            </div>

            {/* Job Search */}
            <input
                type="text"
                placeholder="Search for jobs..."
                value={searchQuery}
                onChange={handleSearchChange}
                style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ddd',
                    marginTop: '15px'
                }}
            />

            {/* Applied Jobs */}
            <h3 style={{ marginTop: '20px' }}>Your Applied Jobs</h3>
            {applications.length === 0 ? (
                <p>You have not applied for any jobs yet.</p>
            ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#007BFF', color: 'white', textAlign: 'left' }}>
                            <th style={{ padding: '10px' }}>Job Title</th>
                            <th style={{ padding: '10px' }}>Company</th>
                        </tr>
                    </thead>
                    <tbody>
                        {applications.map((job, index) => (
                            <tr key={index} style={{ borderBottom: '1px solid #ddd' }}>
                                <td style={{ padding: '10px' }}>{job.title}</td>
                                <td style={{ padding: '10px' }}>{job.company}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            {/* Auto Apply Button */}
            <button onClick={handleAutoApply} style={{ marginTop: '20px', padding: '10px 20px', backgroundColor: '#28a745', color: 'white', borderRadius: '5px', border: 'none' }}>
                Auto-Apply to All Eligible Jobs
            </button>
        </div>
    );
};

export default JobSeekerDashboard;

